// extracted by mini-css-extract-plugin
module.exports = {"root":"_15gpF","searchHeaderSection":"_1Rc5W"};